import { useEffect, useState } from 'react'
import { ConfirmModal } from '../index'
import { useHoldOpen } from '../../../utils/hooks/animation'
import { Button, Spinner } from '@instructure/ui'

const ConfirmWithForm = ({
  action,
  actionMethod,
  authenticityToken,
  confirmButtonCaption,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const loadingIcon = isLoading ? (
    <Spinner
      size="x-small"
      variant="inverse"
      themeOverride={(_, { colors }) => ({
        inverseColor: colors.white,
      })}
    />
  ) : undefined

  return (
    <form action={action} method="post" onSubmit={() => setIsLoading(true)}>
      <input
        type="hidden"
        name="_method"
        value={actionMethod}
        autoComplete="off"
      />
      <input
        type="hidden"
        name="authenticity_token"
        value={authenticityToken}
        autoComplete="off"
      />
      <Button
        renderIcon={loadingIcon}
        disabled={isLoading}
        type="submit"
        color="danger"
        data-qa="confirm_modal_confirm_btn"
      >
        {confirmButtonCaption}
      </Button>
    </form>
  )
}

const ConfirmModalLegacy = ({
  element,
  initialOpen = false,
  authenticityToken,
}) => {
  const [open, setOpen] = useState(initialOpen)
  const [shouldRender, allowUnmount] = useHoldOpen(open)

  useEffect(() => {
    const handleTriggerClick = (e) => {
      e.preventDefault()
      setOpen(true)
    }

    element?.addEventListener('click', handleTriggerClick)

    return () => element?.removeEventListener('click', handleTriggerClick)
  }, [element])

  const {
    message,
    actionMethod,
    confirmButtonCaption,
    cancelButtonCaption,
    heading,
  } = element.dataset

  const action = element.getAttribute('href')

  const handleClose = () => {
    setOpen(false)
  }

  return (
    shouldRender && (
      <ConfirmModal
        open={open}
        heading={heading}
        message={message}
        onCancel={handleClose}
        onConfirm={() => null}
        cancelButtonCaption={cancelButtonCaption}
        onExited={allowUnmount}
        customConfirmButton={
          <ConfirmWithForm
            actionMethod={actionMethod}
            confirmButtonCaption={confirmButtonCaption}
            action={action}
            authenticityToken={authenticityToken}
          />
        }
      />
    )
  )
}

export { ConfirmModalLegacy }
